import React, { Fragment, useEffect, useRef, useState } from 'react';
import useIdleTimer from 'react-idle-timer';
import PropTypes from 'prop-types';
import LoaderView from "../../Components/Indicator/LoaderView";

//fork for https://github.com/luqmanoop/react-lock-screen/blob/master/index.js
function LockScreen(props) {
    const [isDelay, setIsDelay] = useState(false);
    const init = useRef(0);

    useEffect(() => {
        if (!init.current) {
            init.current = 1;
            return;
        }
        //props.isLocked ? props.onScreenLocked() : props.onScreenUnlocked();
        if (props.isLocked)
            setTimeout(() => {
                handleOnIdle();
            }, 300);
        else {
            props.onScreenUnlocked();
            setIsDelay(false);
        }
    });

    const renderLockScreenUi = () => {
        if (isDelay)
            return <LoaderView classname="loaderLocker" header='Обработка данных...' footer='Пожалуйста, подождите!' />;
    };

    const handleClick = (e) => {
        e.stopPropagation();
    }

    const handleOnIdle = () => {
        props.isLocked ? props.onScreenLocked() : props.onScreenUnlocked();

        setIsDelay(props.isLocked);
    }

    const defaultLockScreenStyles = () =>
        isDelay && !props.className
            ? {
                filter: 'blur(4px)',
                userSelect: 'none',
                //height: '100vh',
                overflow: 'hidden',

                height: '100%'

            }
            : {};

    return (
        <Fragment>
            <div
                style={defaultLockScreenStyles()}
                className={`react-lock-screen ${isDelay ? props.className : ''}`}
                onClick={event => isDelay && handleClick(event)}
            >
                {props.children}
            </div>
            {renderLockScreenUi()}
        </Fragment>
    );
}

LockScreen.defaultProps = {
    onScreenLocked: () => { },
    onScreenUnlocked: () => { }
};

LockScreen.propTypes = {
    timeout: PropTypes.number,
    ui: PropTypes.func,
    className: PropTypes.string,
    isLocked: PropTypes.bool,
    onScreenLocked: PropTypes.func,
    onScreenUnlocked: PropTypes.func
};

export default LockScreen;